<template>
    <div class="vx-row">
        <div class="vx-col w-full mb-base">

            <vx-card :title="$t('EditShift') |ToUppercase">
                <div class="vx-row">
                    <small>{{$t('Name') |ToUppercase}}</small><br>
                    <vs-input class="w-full mb-6" type="text" name="name" v-model="shiftName"/>

                    <small class="w-full">{{$t('TimeFrom') |ToUppercase}}</small><br>
                    <flat-pickr :config="configdateTimePicker" v-model="shiftTimeFrom" />
                    <small class="w-full mt-6">{{$t('TimeTo') |ToUppercase}}</small><br>
                    <flat-pickr :config="configdateTimePicker" v-model="shiftTimeTo" />
                </div>
                <div class="vx-row">
                    <div class="vx-col w-full mt-base">
                    <vs-button @click="editShift" class="mr-3 mb-2">{{$t('Edit') | ToUppercase}}</vs-button>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    export default {
        components: {
            flatPickr
        },
        data: function() {
            return {
                shiftId: 0,
                shiftName: "",
                shiftTimeFrom: "",
                shiftTimeTo: "",

                configdateTimePicker: {
                    enableTime: true,
                    noCalendar: true,
                    time_24hr: true
                }
            }
        },
        methods: {
            updateShift() {
                this.$vs.loading();

                const thisIns = this;
                this.$http.get('/shift/' + this.shiftId)
                .then(function (response) {
                    thisIns.shiftId = response.data.id;
                    thisIns.shiftName = response.data.name;
                    thisIns.shiftTimeFrom = response.data.timeFrom;
                    thisIns.shiftTimeTo = response.data.timeTo;
                }).catch(function () {
                    thisIns.$vs.notify({
                        text: "Napaka pri pridobivanju smene",
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }).finally(function () {
                    thisIns.$vs.loading.close();
                });
            },
            editShift() {
                this.$vs.loading();

                const thisIns = this;
                this.$http.put('/shift/', {
                    id: thisIns.shiftId,
                    name: thisIns.shiftName,
                    timeFrom: thisIns.shiftTimeFrom,
                    timeTo: thisIns.shiftTimeTo
                }).then(function (response) {
                    thisIns.$vs.notify({
                        text: "Izmena urejena",
                        color: 'success'
                    });
                    thisIns.$router.push('/shift/all');
                }).catch(function () {
                    thisIns.$vs.notify({
                        text: "Napaka pri shranjevanju",
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }).finally(function () {
                    thisIns.$vs.loading.close();
                });
            }
        },
        created(){
            this.shiftId = this.$route.params.shift_id;
            this.updateShift();
        },
        filters: {
            ToUppercase: function (value) {
            if (!value) return "";
            value = value.toString();
            return value.toUpperCase();
            },
        },
    };
</script>